import { db } from '../firebase';
import { doc, getDoc, getDocs, setDoc, collection } from 'firebase/firestore';

export const getAccount = async (uid) => {
  if (uid !== null) {
    const docRef = doc(db, 'users', uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return null;
    }
  }
};

export const getAdmin = async (uid) => {
  if (uid !== null) {
    const docRef = doc(db, 'admins', uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      return null;
    }
  }
};

export const setAccount = async (accountObj) => {
  if (accountObj?.uid !== null) {
    await setDoc(doc(db, 'users', accountObj.uid), accountObj);
  }

  return true;
};

export const getAllAccounts = async () => {
  const querySnapshot = await getDocs(collection(db, 'users'));
  let accounts = [];
  querySnapshot.forEach((doc) => {
    accounts.push(doc.data());
  });
  return accounts;
};

export const hasAccountAlias = async (uid) => {
  if (uid !== null) {
    const docRef = doc(db, 'users', uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data().alias;
    } else {
      return null;
    }
  }
};
